// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ListItem, { UnorderedList } from "@insite/mobius/Lists";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useContext } from "react";
import { css, ThemeProps, withTheme } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps & ThemeProps<BaseTheme>;

export interface ReplacementForStyles {
    widgeTitle?: TypographyProps;
    productList?: InjectableCss;
    productLink?: LinkPresentationProps;
}

export const replacementForStyles: ReplacementForStyles = {
    widgeTitle: {
        color: "text.main",
        as: "strong",
        css: css`
            display: block;
            font-size: ${pxToRem(18)};
            margin-top: 1em;
            margin-bottom: 0.5em;
        `,
    },
    productList: {
        css: css`
            padding-left: ${pxToRem(14)};
        `,
    },
    productLink: {
        css: css`
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        `,
    },
};

const styles = replacementForStyles;
const ReplacementFor = ({ theme }: Props) => {
    const { product } = useContext(ProductContext);
    if (!product.properties.replacementFor) {
        return null;
    }
    const replacements = JSON.parse(product.properties?.replacementFor);
    return (
        <StyledWrapper>
            <Typography {...styles.widgeTitle}>{translate("Replacement for")}</Typography>
            <UnorderedList {...styles.productList}>
                {replacements.map((replacement: any) => (
                    <ListItem key={replacement.ErpNumber}>
                        <Link href={replacement.Url} {...styles.productLink}>
                            {replacement.ErpNumber}&nbsp;-&nbsp;{replacement.ProductName}
                        </Link>
                    </ListItem>
                ))}
            </UnorderedList>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withTheme(ReplacementFor),
    definition: {
        displayName: "Replacement for description addon",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
